module.exports = __webpack_public_path__ + "static/media/ordenar_columna.26db00b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/ordenar_columna.svg
// module id = 1745
// module chunks = 0